import { runInAction } from 'mobx';
import { AxiosResponse } from 'axios';
import { getResponseBytes, http } from 'services/base/http';
import { IPangolinDomain, NetworkCounters } from './types';
import { GetNetworkCountersResponse, NetworkCountersObject } from './protos/network_pb';


export class CountersService {
  static async fetchAll(domain: IPangolinDomain): Promise<NetworkCounters> {
    const httpResp = await http.get(`/pangolin/${domain.id}/network/counters`);
    return runInAction(() => {
      const counters = parseNetworkCountersResponse(httpResp);
      domain.counters = counters;
      return counters;
    });
  }
}

function parseNetworkCountersResponse(httpResp: AxiosResponse): NetworkCounters {
  const response = GetNetworkCountersResponse.deserializeBinary(getResponseBytes(httpResp));
  const counters = createCountersFromProto(response.getCounters());
  return counters;
}

function createCountersFromProto(proto: NetworkCountersObject): NetworkCounters {
  return {
    filtersTotal: proto.getFiltersTotal() ?? 0,
    filtersBlocked: proto.getFiltersBlocked() ?? 0,

    adblockTotal: proto.getAdblockTotal() ?? 0,
    adblockBlocked: proto.getAdblockBlocked() ?? 0,

    maliciousTotal: proto.getMaliciousTotal() ?? 0,
    maliciousBlocked: proto.getMaliciousBlocked() ?? 0,

    malwareTotal: proto.getMalwareTotal() ?? 0,
    malwareBlocked: proto.getMalwareBlocked() ?? 0,
  };
}
